import { render, staticRenderFns } from "./KassenbuchPopover.vue?vue&type=template&id=abbd014a&"
import script from "./KassenbuchPopover.vue?vue&type=script&lang=ts&"
export * from "./KassenbuchPopover.vue?vue&type=script&lang=ts&"
import style0 from "./KassenbuchPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports